export class Auth {
  public loggedIn() {
    const token = sessionStorage.getItem('access_token');
    if (token) {
      return true;
    }
  }
}
